module.exports = __webpack_public_path__ + "img/wirfuerschule_logo_white.e18712dd.png";